import { atomEffect } from './atomEffect.js';
import { isDev } from './env.js';
export function withAtomEffect(targetAtom, effect) {
    const effectAtom = atomEffect((get, set) => {
        const getter = ((a) => a === targetWithEffect ? get(targetAtom) : get(a));
        getter.peek = get.peek;
        return targetWithEffect.effect(getter, set);
    });
    if (isDev()) {
        Object.defineProperty(effectAtom, 'debugLabel', {
            get: () => `${targetWithEffect.debugLabel ?? 'atomWithEffect'}:effect`,
        });
        effectAtom.debugPrivate = true;
    }
    const descriptors = Object.getOwnPropertyDescriptors(targetAtom);
    descriptors.read.value = (get) => {
        try {
            return get(targetAtom);
        }
        finally {
            get(effectAtom);
        }
    };
    if ('write' in targetAtom && typeof targetAtom.write === 'function') {
        descriptors.write.value = targetAtom.write.bind(targetAtom);
        delete descriptors.onMount;
    }
    // avoid reading `init` to preserve lazy initialization
    const targetPrototype = Object.getPrototypeOf(targetAtom);
    const targetWithEffect = Object.create(targetPrototype, descriptors);
    targetWithEffect.effect = effect;
    return targetWithEffect;
}
//# sourceMappingURL=withAtomEffect.js.map